module.exports = __webpack_public_path__ + "img/icon-application-new.e893c15.svg";